<template>
  <div class="pc-ticket">
    <!-- 与 ticket 页同款的 pc-ticket__hero -->
    <header class="pc-ticket__hero">
      <img
        class="pc-ticket__hero-bg"
        src="@/assets/image/streaming/page_bg.webp"
        alt="Streaming ticket page background"
        width="1920"
        height="1420"
        decoding="async"
        loading="lazy"
      />
      <img
        class="pc-ticket__kv"
        src="@/assets/image/ticket/header_bg.webp"
        alt="Streaming ticket page header background illustration (decorative)"
        width="1798"
        height="1135"
        decoding="async"
        loading="lazy"
      />
      <img
        class="pc-ticket__title-img"
        src="@/assets/image/streaming/title.webp"
        alt="Streaming ticket page title graphic"
        width="870"
        height="68"
        decoding="async"
        loading="lazy"
      />
      <img
        class="pc-ticket__deco pc-ticket__deco--left"
        src="@/assets/image/streaming/nav_icon_video.webp"
        alt="Decorative video-themed graphic (left)"
        width="501"
        height="478"
        decoding="async"
        loading="lazy"
      />
      <img
        class="pc-ticket__deco pc-ticket__deco--right"
        src="@/assets/image/streaming/nav_icon_circular.webp"
        alt="Decorative circular graphic (right)"
        width="454"
        height="442"
        decoding="async"
        loading="lazy"
      />

      <!-- 与首页 pc-index__about-wrap-footer 同款无限滚动 -->
      <div
        class="pc-ticket__hero-marquee-slot pc-ticket__hero-marquee-slot--top"
      >
        <div class="pc-index__about-wrap-footer">
          <div class="pc-index__about-wrap-footer-inner-notify">
            <div class="pc-index__about-wrap-footer-inner-notify-track">
              <div
                v-for="dup in 2"
                :key="'streaming-hero-marquee-' + dup"
                class="pc-index__about-wrap-footer-inner-notify-group"
                :aria-hidden="dup === 2 ? 'true' : undefined"
              >
                <img
                  v-for="n in 10"
                  :key="`streaming-hero-${dup}-${n}`"
                  class="pc-index__about-wrap-footer-inner-notify-title"
                  src="@/assets/image/streaming/nav_footer_title.webp"
                  width="314"
                  height="30"
                  alt="Scrolling footer title strip (decorative)"
                  aria-hidden="true"
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section
        class="pc-ticket__panel"
        :aria-label="pcStreamingCopy.liveTicket.ariaLabel"
      >
        <div class="pc-ticket__lead">
          <div class="pc-ticket__lead-head">
            <h2 class="pc-ticket__lead-title">
              {{ pcStreamingCopy.liveTicket.title }}
            </h2>
            <p class="pc-ticket__lead-price">
              {{ pcStreamingCopy.liveTicket.price }}
            </p>
          </div>
          <div
            class="pc-ticket__lead-divider"
            role="presentation"
            aria-hidden="true"
          />
          <div class="pc-ticket__lead-period">
            <span class="pc-ticket__lead-badge">{{
              pcStreamingCopy.liveTicket.periodBadge
            }}</span>
            <p class="pc-ticket__lead-range">
              {{ pcStreamingCopy.liveTicket.periodRange }}
            </p>
          </div>
        </div>

        <img
          class="pc-ticket__line"
          src="@/assets/image/ticket/card_line.webp"
          alt=""
          width="1209"
          height="70"
          decoding="async"
          loading="lazy"
          role="presentation"
        />

        <div
          class="pc-ticket__notes"
          role="region"
          aria-labelledby="ticket-notes-h"
        >
          <h2
            id="ticket-notes-h"
            class="pc-ticket__notes-h"
            v-html="pcStreamingCopy.noticeHeadingHtml"
          ></h2>
          <ul class="pc-ticket__notes-ul">
            <li v-for="(line, idx) in liveNoticeLines" :key="'n-' + idx">
              <span v-html="'・' + line"></span>
            </li>
          </ul>
        </div>
      </section>

      <section
        class="pc-ticket__panel"
        :aria-label="pcStreamingCopy.archive.ariaLabel"
      >
        <div class="pc-ticket__lead">
          <div class="pc-ticket__lead-head">
            <h2 class="pc-ticket__lead-title">
              {{ pcStreamingCopy.archive.title }}
            </h2>
            <p class="pc-ticket__lead-price" aria-hidden="true"></p>
          </div>
          <div
            class="pc-ticket__lead-divider"
            role="presentation"
            aria-hidden="true"
          />
          <div class="pc-ticket__lead-period">
            <span class="pc-ticket__lead-badge">{{
              pcStreamingCopy.archive.periodBadge
            }}</span>
            <p class="pc-ticket__lead-range">
              {{ pcStreamingCopy.archive.periodRange }}
            </p>
          </div>
        </div>

        <img
          class="pc-ticket__line"
          src="@/assets/image/ticket/card_line.webp"
          alt=""
          width="1209"
          height="70"
          decoding="async"
          loading="lazy"
          role="presentation"
        />

        <div
          class="pc-ticket__notes"
          role="region"
          aria-labelledby="ticket-archive-notes-h"
        >
          <h2
            id="ticket-archive-notes-h"
            class="pc-ticket__notes-h"
            v-html="pcStreamingCopy.noticeHeadingHtml"
          ></h2>
          <ul class="pc-ticket__notes-ul">
            <li v-for="(line, idx) in archiveNoticeLines" :key="'na-' + idx">
              <span v-html="'・' + line"></span>
            </li>
          </ul>
        </div>
      </section>
    </header>
  </div>
</template>

<script>
import streamingContent from "@/views/data/streaming-content.json";

/**
 * 配信页：文案维护 streaming-content.json；图片路径在模板中写死
 */
export default {
  name: "PcStreamingPage",
  data() {
    return {
      // ========== 运营 / 页面配置（优先维护）==========
      pcStreamingCopy: streamingContent.pcStreamingCopy,
      liveNoticeLines: streamingContent.liveNoticeLines,
      archiveNoticeLines: streamingContent.archiveNoticeLines,
    };
  },
};
</script>

<style lang="scss" scoped>
/* 与 ticket 页 pc-ticket__hero 及子元素样式一致（不含 __main） */
.pc-ticket {
  background-color: #3c3068;
  box-sizing: border-box;
  text-align: left;

  img {
    box-sizing: border-box;
    vertical-align: middle;
  }

  &__hero {
    position: relative;
    width: 100%;
    padding-top: 500px;
    box-sizing: border-box;
    background-image: url("@/assets/image/ticket/nav_bg.webp");
    background-size: 100% auto;
    background-repeat: no-repeat;
    border-bottom: 2px solid #9f77bb;

    .pc-ticket__hero-bg {
      position: absolute;
      top: 0;
      left: 50%;
      width: 100vw;
      max-width: none;
      height: 1420px;
      transform: translateX(-50%);
      object-fit: cover;
      object-position: center;
    }

    .pc-ticket__kv {
      position: absolute;
      top: 431px;
      left: 69px;
      width: 1798px;
      height: 1135px;
      object-fit: contain;
      z-index: -1;
      object-position: center;
    }

    .pc-ticket__title-img {
      position: absolute;
      top: 193px;
      left: 526px;
      width: 868px;
      object-fit: contain;
      object-position: center;
    }

    .pc-ticket__deco {
      position: absolute;
      object-fit: contain;
      object-position: center;
      transform-origin: center center;
      will-change: transform;
      animation: pc-ticket-deco-beat 1.35s infinite;

      &--left {
        top: 20px;
        left: 124px;
        width: 460px;
      }

      &--right {
        top: 20px;
        right: 100px;
        width: 360px;
      }
    }

    /* 跑马灯槽位：与首页 pc-index__about-wrap 底部条同款视觉与动画 */
    .pc-ticket__hero-marquee-slot {
      position: absolute;
      left: 0;
      width: 100%;
      height: 134px;
      padding-top: 1px;
      box-sizing: border-box;
      z-index: 10;

      &--top {
        top: 306px;
      }

      .pc-index__about-wrap-footer {
        padding-top: 45px;
        position: relative;
        width: 100%;
        height: 100%;
        background-image: url("@/assets/image/index/about_footer_bg.webp");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }

      .pc-index__about-wrap-footer-inner-notify {
        overflow: hidden;
        background-color: #191616;
        height: 44px;
        display: flex;
        align-items: center;
        border-top: 1px solid #d9a2ff;
        border-bottom: 1px solid #d9a2ff;
      }

      .pc-index__about-wrap-footer-inner-notify-track {
        display: flex;
        width: max-content;
        flex-shrink: 0;
        align-items: center;
        animation: pc-index-notify-marquee 45s linear infinite;
        will-change: transform;

        @media (prefers-reduced-motion: reduce) {
          animation: none;
          will-change: auto;
        }
      }

      .pc-index__about-wrap-footer-inner-notify-group {
        display: flex;
        flex-shrink: 0;
        align-items: center;
      }

      .pc-index__about-wrap-footer-inner-notify-title {
        flex-shrink: 0;
        margin-right: 30px;
        width: 314px;
        height: 30px;
        object-fit: contain;
        object-position: center;
      }
    }

    .pc-ticket__panel {
      position: relative;
      z-index: 11;
      margin: 0 auto 60px;
      width: 1200px;
      max-width: calc(100% - 48px);
      padding: 60px 0 56px;
      border: 1px solid #fff380;
      border-radius: 8px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 0;
      background-color: rgba(5, 5, 16, 0.4);

      .pc-ticket__lead {
        margin: 0 auto;
        width: 100%;
        max-width: 658px;
        box-sizing: border-box;

        .pc-ticket__lead-head {
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          gap: 12px 28px;
          padding: 0 50px;
        }

        .pc-ticket__lead-title {
          margin: 0;
          font-size: 18px;
          font-weight: 800;
          letter-spacing: 0.02em;
          line-height: 1.35;
          color: #d9a2ff;
        }

        .pc-ticket__lead-price {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #fff;
          line-height: 1.4;
          white-space: nowrap;
        }

        .pc-ticket__lead-divider {
          height: 0;
          margin: 20px 0 22px;
          border: 0;
          border-top: 1px solid rgba(255, 255, 255, 0.9);
        }

        .pc-ticket__lead-period {
          display: flex;
          flex-wrap: wrap;
          align-items: stretch;
          padding: 0 0 0 40px;
        }

        .pc-ticket__lead-badge {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 4px 20px;
          box-sizing: border-box;
          font-size: 14px;
          font-weight: 700;
          color: #fff;
          text-align: center;
          background: rgba(0, 0, 0, 0.25);
          border-radius: 4px;
          margin-right: 20px;
        }

        .pc-ticket__lead-range {
          flex: 1;
          min-width: 0;
          margin: 0;
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: 600;
          color: #fff;
          line-height: 1.55;
        }

        @media (max-width: 720px) {
          padding-left: 24px;
          padding-right: 24px;

          .pc-ticket__lead-head {
            flex-direction: column;
            align-items: flex-start;
          }

          .pc-ticket__lead-period {
            flex-direction: column;
            align-items: stretch;
          }

          .pc-ticket__lead-badge {
            min-width: unset;
            width: 100%;
            max-width: 220px;
          }
        }
      }

      .pc-ticket__line {
        display: block;
        width: 100%;
        height: auto;
        object-fit: cover;
        object-position: center;
        margin: 24px 0 0;
      }

      /* 与 ticket/index.vue 中 .pc-ticket__hero .pc-ticket__panel .pc-ticket__notes 一致 */
      .pc-ticket__notes {
        padding: 24px 260px 0 300px;
        box-sizing: border-box;

        .pc-ticket__notes-h {
          margin: 0 0 6px;
          font-size: 14px;
          color: #fff;
          letter-spacing: 0.04em;
        }

        .pc-ticket__notes-ul {
          margin: 0;
          padding: 0;
          list-style: none;
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.92);
          line-height: 1.65;

          li {
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}

@keyframes pc-ticket-deco-beat {
  0%,
  42% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
  }
  52% {
    transform: scale(0.9);
    animation-timing-function: cubic-bezier(0.55, 0.05, 0.6, 0.45);
  }
  58% {
    transform: scale(0.86);
    animation-timing-function: cubic-bezier(0.33, 1.15, 0.52, 1);
  }
  70% {
    transform: scale(1.08);
    animation-timing-function: cubic-bezier(0.22, 0.85, 0.38, 1);
  }
  80% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  100% {
    transform: scale(1);
  }
}

/* 与首页 index.vue 中 pc-index-notify-marquee 相同 */
@keyframes pc-index-notify-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
